import React from 'react';
import styles from './Toast.module.css';

const getIcon = (type: string) => {
  switch (type) {
    case 'success':
      return 'pi-check-circle';
    case 'info':
      return 'pi-info-circle';
    case 'warn':
      return 'pi-exclamation-triangle';
    case 'error':
      return 'pi-times-circle';
    default:
      return 'pi-info-circle';
  }
};

const Toast: React.FC<{ type: string; title: string }> = ({ type, title }) => {
  const icon = getIcon(type);
  return (
    <div className={`${styles.toastMessage} ${styles[`${type}Toast`]}`}>
      <div className={`${styles.iconWrapper} ${styles[`${type}Icon`]}`}>
        <i className={`pi ${icon}`}></i>
      </div>
      <div className={styles.textWrapper}>
        <div className={styles.title}>{title}</div>
      </div>
    </div>
  );
};

export default Toast;
